// extracted by mini-css-extract-plugin
export default {"photoUploader":"PhotoUploader_photoUploader__FVUMD","imageContainer":"PhotoUploader_imageContainer__8Vx-B","image":"PhotoUploader_image__1UJpk"};